import templateUrl from "emun.order/order-notes.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import orderConfig from "emun.order/order.config";

class OrderNotesController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = orderConfig;
    $ctrl.views = {
      list: "th-list",
      cards: "th",
    };
    $ctrl.view = "list";
    $ctrl.canEdit = this.order.canEdit;
    $ctrl.bus = new ServiceBus();
    if (this.order) {
      $ctrl.notes = new AutoQuery({
        url: "QueryOrderNotes.json?OrderNumber=" + this.order.id,
        orderBy: "-CreatedOn",
        autoLoad: true,
        pageSize: $ctrl.view === "list" ? 10 : 1000,
      });
    }
    $ctrl.$on("orderNoteSaved", () => $ctrl.notes.load(true));
    $ctrl.$on("orderNoteDeleted", () => $ctrl.notes.load(true));
    $ctrl.deleteNote = function (note) {
      return modals
        .confirm("Are you sure?", "Delete Note")
        .result.then(function () {
          $ctrl.bus
            .send("DeleteOrderNote.json", note)
            .then(function (response) {
              $ctrl.$emit("orderNoteDeleted", $ctrl);
            });
        });
    };
  }
  setView(view) {
    let $ctrl = this;
    $ctrl.view = view;
    if (view === "list") $ctrl.notes.pageSize = 10;
    else if (view === "cards") $ctrl.notes.pageSize = 1000;
    $ctrl.notes.load(true);
  }
}

export default {
  bindings: {
    order: "<",
  },
  controller: OrderNotesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
